import React, { useState } from 'react';
import LeftBar from './LeftBar';
import Content from './Content';
import BottomBar from './BottomBar';
const HomeLayout = ({ authenticateUser, showContent, ShowNextButtons, children }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageChange = (newPage) => {setCurrentPage(newPage);};
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [dropValue, setdropValue] = useState(null);  const [drop2, setDrop2] = useState(null);  const [drop3, setDrop3] = useState(null);
  const handleDrop1Change = (newDrop1Value) => {setdropValue(newDrop1Value); };
  const [isLeftbarVisible, setIsLeftbarVisible] = useState(true);
  const toggleLeftbar = () => {setIsLeftbarVisible(prevState => !prevState);};

  return (
    <div className="app-container">
      <LeftBar onPageChange={handlePageChange} onNodeSelect={setSelectedNode} onChildSelect={setSelectedChild}  onDrop1Change={handleDrop1Change} toggleLeftbar={toggleLeftbar} isLeftbarVisible={isLeftbarVisible}/>
      <div className={`content coneten-xl ${isLeftbarVisible ? '' : 'contet-without-leftbar'}`}> 
        {showContent && (<Content currentPage={currentPage} selectedNode={selectedNode} selectedChild={selectedChild} dropValue={dropValue} toggleLeftbar={toggleLeftbar} isLeftbarVisible={isLeftbarVisible} />)}
        {children && (<div className='h-100 w-100 flex-center'>{children}</div>)}        
        {/* {ShowNextButtons && (<BottomBar currentPage={currentPage}  onPageChange={handlePageChange} />)} */}
      </div>
 
    </div>
  );
};

export default HomeLayout;